import { render, staticRenderFns } from "./WesternPriceChance.vue?vue&type=template&id=6934eb57&scoped=true"
import script from "./WesternPriceChance.vue?vue&type=script&lang=js"
export * from "./WesternPriceChance.vue?vue&type=script&lang=js"
import style0 from "./WesternPriceChance.vue?vue&type=style&index=0&id=6934eb57&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6934eb57",
  null
  
)

export default component.exports